import React from 'react'
import {
  MenuButton,
  MenuList,
  Menu,
  Text,
  MenuOptionGroup,
  Button,
  Box,
  BoxProps,
  Skeleton,
  useMediaQuery,
  useColorModeValue
} from '@chakra-ui/react'
import { VscChevronDown, VscChevronUp } from 'react-icons/vsc'
import { useTranslation } from 'react-i18next'

type SelectCheckboxMenuProps = {
  buttonTitle?: string
  onChange?: (values?: any) => void
  title?: string
  label?: string
  type?: 'checkbox' | 'radio'
  closeOnSelect?: boolean
  isLoaded?: boolean
} & BoxProps

const SelectCheckboxMenu: React.FC<SelectCheckboxMenuProps> = ({
  buttonTitle,
  children,
  onChange,
  label,
  title,
  type,
  mr,
  isLoaded,
  closeOnSelect,
  defaultValue,
  ...rest
}) => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const { t } = useTranslation()
  return (
    <Box {...rest} mr={isTabletOrMobile ? 0 : mr}>
      {label && (
        <Skeleton isLoaded={isLoaded} minW="fit-content" my={2}>
          <Text fontSize="xs" fontWeight="semibold" w="fit-content">
            {label}
          </Text>
        </Skeleton>
      )}
      <Skeleton isLoaded={isLoaded}>
        <Menu closeOnSelect={closeOnSelect}>
          {({ isOpen }) => (
            <>
              <MenuButton
                as={Button}
                textAlign="left"
                py={6}
                fontWeight="semibold"
                rounded="lg"
                width="100%"
                rightIcon={isOpen ? <VscChevronUp /> : <VscChevronDown />}
              >
                <Text fontSize="xs">{buttonTitle ? buttonTitle : t('any')}</Text>
              </MenuButton>
              <MenuList
                fontSize="sm"
                borderColor={useColorModeValue('gray.100', 'gray.700')}
                maxH={350}
                overflowY="auto"
                minW="180px"
              >
                <MenuOptionGroup
                  defaultValue={defaultValue as string[]}
                  onChange={onChange}
                  title={title}
                  type={type}
                >
                  {children}
                </MenuOptionGroup>
              </MenuList>
            </>
          )}
        </Menu>
      </Skeleton>
    </Box>
  )
}
SelectCheckboxMenu.defaultProps = {
  title: 'Title',
  type: 'checkbox',
  closeOnSelect: false,
  isLoaded: true,
  mr: 0,
  my: 2
}
export default React.memo(SelectCheckboxMenu)
